import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

/** `2026-09-29` → `Sep 29, 2026`; null → `—`. */
export function fmtDate(dateOnly: string | null | undefined): string {
  if (!dateOnly) return '—';
  return format(parseISO(`${dateOnly}T00:00:00`), 'MMM d, yyyy');
}

/** ISO timestamp → `Sep 29, 2026 · 3:04 PM` in the viewer's timezone; null → `—`. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return format(parseISO(iso), 'MMM d, yyyy · h:mm a');
}

/** ISO timestamp → `3 days ago`; null → `never`. */
export function fmtAgo(iso: string | null | undefined): string {
  if (!iso) return 'never';
  return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
